// admin/src/utils/logger.js
const LOG_LEVELS = {
  ERROR: 0,
  WARN: 1,
  INFO: 2,
  DEBUG: 3
};

class Logger {
  constructor() {
    this.level = LOG_LEVELS.INFO;
  }

  setLevel(level) {
    this.level = level;
  }

  formatMessage(level, message, data = null) {
    const timestamp = new Date().toISOString();
    const logEntry = {
      timestamp,
      level,
      message,
      ...(data && { data })
    };
    return logEntry;
  }

  error(message, data = null) {
    if (this.level >= LOG_LEVELS.ERROR) {
      const logEntry = this.formatMessage('ERROR', message, data);
      console.error('?��', logEntry);
    }
  }

  warn(message, data = null) {
    if (this.level >= LOG_LEVELS.WARN) {
      const logEntry = this.formatMessage('WARN', message, data);
      console.warn('?��', logEntry);
    }
  }

  info(message, data = null) {
    if (this.level >= LOG_LEVELS.INFO) {
      const logEntry = this.formatMessage('INFO', message, data);
      console.info('?��', logEntry);
    }
  }

  debug(message, data = null) {
    if (this.level >= LOG_LEVELS.DEBUG) {
      const logEntry = this.formatMessage('DEBUG', message, data);
      console.debug('?��', logEntry);
    }
  }
}

const logger = new Logger();

export { LOG_LEVELS };
export default logger;
